import React from "react";
import { apiRoutes } from "../../../hooks/apiClient";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import funcionalidades from "../../../context/AuthContext.funcionalidades";

const columns = [
  {
    name: "Nome",
    selector: "descricao",
    width: "67%",
    sortable: true,
  },
  {
    name: "Nº Máximo de Dias da OS",
    selector: "qtdeMaximaDias",
    width: "270px",
    sortable: true,
    center: true,
  },
  {
    name: "Situação",
    selector: "ativoDescricao",
    sortable: true,
    width: "140px",
    center: true,
  },
];

const ConsultaTipoAcaoFiscal = ({ history, match }) => (
  <PaginatedView
    title="Tipo de Ação Fiscal"
    keyField="codigo"
    descriptionField="descricao"
    defaultSearch
    defaultSearchPlaceholder="Digite a descrição"
    queryService={apiRoutes.fiscalizacao.parametrizacao.consultaTipoAcaoFiscal}
    deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiTipoAcaoFiscal}
    editRoute={`${match.url}/form`}
    columns={columns}
    permissionDelete={funcionalidades.tipoAcaoFiscal.deletar}
    permissionInsert={funcionalidades.tipoAcaoFiscal.inserir}
    history={history}
  />
);

export default ConsultaTipoAcaoFiscal;
